import * as React from 'react';
import { cn } from '@/lib/utils';
import { Input } from './input';

export interface CurrencyInputProps
	extends Omit<React.ComponentProps<'input'>, 'type'> {
	currencySymbol?: string;
	currencyPosition?: 'left' | 'right';
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
	(
		{
			className,
			currencySymbol = '€',
			currencyPosition = 'right',
			...props
		},
		ref
	) => {
		return (
			<div className="relative">
				{currencyPosition === 'left' && (
					<span className="text-muted-foreground pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm font-medium">
						{currencySymbol}
					</span>
				)}
				<Input
					type="number"
					step="0.01"
					min="0"
					className={cn(
						currencyPosition === 'left' ? 'pl-7' : 'pr-7',
						className
					)}
					ref={ref}
					{...props}
				/>
				{currencyPosition === 'right' && (
					<span className="text-muted-foreground pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium">
						{currencySymbol}
					</span>
				)}
			</div>
		);
	}
);

CurrencyInput.displayName = 'CurrencyInput';

export { CurrencyInput };
